export const colonosRoutes = {
    path: '/',
    name: 'colonos',
    redirect: '/inicio',
    component: () => import('@/modules/colonos/layouts/ColonosLayout.vue'),
    children: [
        {
            path: 'inicio',
            name: 'Home',
            component: () => import('@/views/Home.vue')
        },
        {
            path: 'nosesion',
            name: 'NoSesion',
            component: () => import('@/views/NoSesion.vue')
        },
        {
            path: 'olvido',
            name: 'OlvidoPass',
            component: () => import('@/views/OlvidoPass.vue')
        },
        {
            path: 'perfil',
            name: 'Perfil',
            component: () => import('@/views/Perfil.vue')
        },
        // ===========================
        // INFORMACIÓN GENERAL
        // ========================= */
        {
            path: 'noticias',
            name: 'Noticias',
            component: () => import('@/views/Noticias.vue')
        },
        {
            path: 'detallenoticia/:id',
            name: 'DetalleNoticia',
            component: () => import('@/views/DetalleNoticia.vue')
        },
        {
            path: 'galeria',
            name: 'Galeria',
            component: () => import('@/views/Galeria.vue')
        },
        {
            path: 'sitiosInteres',
            name: 'SitiosInteres',
            component: () => import('@/views/SitiosInteres.vue')
        },
        /* ===========================
        * REGLAMENTOS
        * ========================= */
        {
            path: 'regconstruc',
            name: 'ReglamentoConstruccion',
            component: () => import('@/views/ReglamentoConstruccion.vue'),
            meta: {rutaProtegida: true}
        },
        {
            path: 'reginstalaciones',
            name: 'ReglamentoInstalaciones',
            component: () => import('@/views/ReglamentoInstalaciones.vue'),
            meta: {rutaProtegida: true}
        },
        {
            path: 'regimencondom',
            name: 'RegimenCondominio',
            component: () => import('@/views/RegimenCondominio.vue'),
            meta: {rutaProtegida: true}
        },
        /* ===========================
        * FINANZAS
        * ========================= */
        {
            path: 'consultasaldo',
            name: 'ConsultaSaldo',
            component: () => import('@/views/ConsultaSaldo.vue'),
            meta: {rutaProtegida: true}
        },
        {
            path: 'consumoagua',
            name: 'ConsumoAgua',
            component: () => import('@/views/ConsumoAgua.vue')
        },
        {
            path: 'consultapagos',
            name: 'ConsultaPagos',
            component: () => import('@/views/ConsultaPagos.vue'),
            meta: {rutaProtegida: true}
        },
        {
            path: 'pagos',
            name: 'Pagos',
            component: () => import('@/views/Pagos.vue'),
            meta: {rutaProtegida: true}
        },
        {
            path: 'finalizapago',
            name: 'FinalizarPago',
            component: () => import('@/views/FinalizarPago.vue'),
            meta: {rutaProtegida: true}
        },
        {
            path: 'inffinan',
            name: 'InformacionFinanciera',
            component: () => import('@/views/InformacionFinanciera.vue'),
            meta: {rutaProtegida: true}
        },
        {
            path: 'reportes',
            name: 'Reportes',
            component: () => import('@/views/Reportes.vue'),
            meta: {rutaProtegida: true}
        },
        {
            path: 'minutas',
            name: 'Minutas',
            component: () => import('@/views/Minutas.vue'),
            meta: {rutaProtegida: true}
        },
        /* ===========================
        * CONTACTO
        * ========================= */
        {
            path: 'contacto',
            name: 'Contacto',
            component: () => import('@/views/Contacto.vue')
        },
        {
            path: 'directorio',
            name: 'Directorio',
            component: () => import('@/views/Directorio.vue')
        },
        {
            path: 'mesa',
            name: 'MesaDirectiva',
            component: () => import('@/views/MesaDirectiva.vue')
        },
        {
            path: 'aviso',
            name: 'AvisoPrivacidad',
            component: () => import('@/views/AvisoPrivacidad.vue')
        },
    ]
}